import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/reject_reason_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  reason_cont: {
    model_name: 'RejectReason',
    column_type: 'string',
    label_key_path: 'rejectReason.reason',
  },
  kind_eq: {
    column_type: 'enum',
    extra: {
      options: ['admin_reject_apply', 'cheif_pattern_making_officier_reject_product_design', 'merchandiser_reject_order', 'boss_reject_order', 'product_design_overdue', 'order_overdue', 'sales_director_reject_order', 'supplier_reject_order', 'sales_director_reject_product_design', 'supplier_reject_product_design', 'supplier_boss_reject_product_design', 'reject_product_design_make_plate', 'reject_product_design_cut', 'reject_product_design_sew', 'admin_reject_order', 'accessory_reject_order', 'reject_product_design_craft'],
    },
    model_name: 'RejectReason',
    label_key_path: 'rejectReason.kind',
  },
}
export const formColumnsConfig = {
  'self': {
    'reason': { required: true, disabledUpdate: false },
    'kind': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('RejectReason', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('RejectReason', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
